import Vue from 'vue'
import Vuex from 'vuex'
// load vuex i18n module
import VuexI18n from 'vuex-i18n'

// initialize the vuex store using the vuex module.
const store = new Vuex.Store();

// initialize the internationalization plugin on the vue instance.
Vue.use(VuexI18n.plugin, store, {
    onTranslationNotFound (locale, key) {
        // eslint-disable-next-line
        console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`);
    }
});

const { locale, translations } = window.config;
// Adding translations directly to the application

Vue.i18n.add(locale[0], translations[0]);
Vue.i18n.add(locale[1], translations[1]);

// set the start locale to use
Vue.i18n.set(locale[0]);

export default VuexI18n